import { FilterName } from '../../__generated__/fed-graphql-types'
import { Channel } from '@at/sauron-platform-core'
import { ChannelSearchTypeKey } from '../../utils/channel-utilities'

export const defaultChannelGroupFiltersOrder: Map<ChannelSearchTypeKey, FilterName[]> = new Map()

defaultChannelGroupFiltersOrder.set(Channel.cars, [
    FilterName.part_exchange_available,
    FilterName.distance,
    FilterName.category_tag,
    FilterName.make,
    FilterName.model,
    FilterName.aggregated_trim,
    FilterName.with_digital_retailing,
    FilterName.price_search_type,
    FilterName.min_price,
    FilterName.min_monthly_price,
    FilterName.max_price,
    FilterName.max_monthly_price,
    FilterName.min_year_manufactured,
    FilterName.max_year_manufactured,
    FilterName.min_mileage,
    FilterName.max_mileage,
    FilterName.transmission,
    FilterName.body_type,
    FilterName.colour,
    FilterName.doors_values,
    FilterName.seats_values,
    FilterName.fuel_type,
    FilterName.battery_range_values,
    FilterName.battery_charge_time_values,
    FilterName.min_engine_size,
    FilterName.max_engine_size,
    FilterName.min_engine_power,
    FilterName.max_engine_power,
    FilterName.acceleration_values,
    FilterName.fuel_consumption_values,
    FilterName.co2_emission_values,
    FilterName.annual_tax_values,
    FilterName.insurance_group,
    FilterName.drivetrain,
    FilterName.boot_size_values,
    FilterName.seller_type,
    FilterName.is_writeoff,
    FilterName.keywords,
    FilterName.is_manufacturer_approved,
    FilterName.ni_only,
])
defaultChannelGroupFiltersOrder.set('cars-leasing', [
    FilterName.aggregated_trim,
    FilterName.battery_charge_time_values,
    FilterName.battery_range_values,
    FilterName.body_type,
    FilterName.fuel_type,
    FilterName.lease_in_stock,
    FilterName.make,
    FilterName.max_engine_size,
    FilterName.max_lease_monthly_price,
    FilterName.max_lease_monthly_price_ex_vat,
    FilterName.min_engine_size,
    FilterName.min_lease_monthly_price,
    FilterName.min_lease_monthly_price_ex_vat,
    FilterName.model,
    FilterName.seats_values,
    FilterName.transmission,
])
defaultChannelGroupFiltersOrder.set(Channel.cycles, [
    FilterName.make,
    FilterName.model,
    FilterName.style,
    FilterName.min_frame_size_cm,
    FilterName.max_frame_size_cm,
    FilterName.min_price,
    FilterName.max_price,
    FilterName.colour,
    FilterName.keywords,
])
defaultChannelGroupFiltersOrder.set(Channel.vans, [
    FilterName.distance,
    FilterName.make,
    FilterName.model,
    FilterName.with_digital_retailing,
    FilterName.price_search_type,
    FilterName.min_price,
    FilterName.min_monthly_price,
    FilterName.max_price,
    FilterName.max_monthly_price,
    FilterName.vat_status,
    FilterName.min_year_manufactured,
    FilterName.max_year_manufactured,
    FilterName.min_mileage,
    FilterName.max_mileage,
    FilterName.body_type,
    FilterName.transmission,
    FilterName.wheelbase,
    FilterName.fuel_type,
    FilterName.colour,
    FilterName.seats_values,
    FilterName.doors_values,
    FilterName.cab_type,
    FilterName.min_engine_size,
    FilterName.max_engine_size,
    FilterName.min_engine_power,
    FilterName.max_engine_power,
    FilterName.fuel_consumption_values,
    FilterName.co2_emission_values,
    FilterName.seller_type,
    FilterName.is_writeoff,
    FilterName.keywords,
    FilterName.is_manufacturer_approved,
    FilterName.ni_only,
])

defaultChannelGroupFiltersOrder.set('vans-leasing', [
    FilterName.body_type,
    FilterName.cab_type,
    FilterName.fuel_type,
    FilterName.lease_in_stock,
    FilterName.make,
    FilterName.max_engine_size,
    FilterName.max_lease_monthly_price,
    FilterName.max_lease_monthly_price_ex_vat,
    FilterName.min_engine_size,
    FilterName.min_lease_monthly_price,
    FilterName.min_lease_monthly_price_ex_vat,
    FilterName.model,
    FilterName.price_search_type,
    FilterName.seats_values,
    FilterName.transmission,
    FilterName.wheelbase,
])

defaultChannelGroupFiltersOrder.set(Channel.trucks, [
    FilterName.distance,
    FilterName.make,
    FilterName.model,
    FilterName.style,
    FilterName.sub_style,
    FilterName.body_type,
    FilterName.min_year_manufactured,
    FilterName.max_year_manufactured,
    FilterName.min_price,
    FilterName.max_price,
    FilterName.poa,
    FilterName.axle_config,
    FilterName.min_gross_vehicle_weight,
    FilterName.max_gross_vehicle_weight,
    FilterName.min_engine_power,
    FilterName.max_engine_power,
    FilterName.transmission,
    FilterName.fuel_type,
    FilterName.emission_class,
    FilterName.cab_type,
    FilterName.min_mileage_km,
    FilterName.max_mileage_km,
    FilterName.driver_position,
    FilterName.keywords,
])
defaultChannelGroupFiltersOrder.set(Channel.farm, [
    FilterName.distance,
    FilterName.make,
    FilterName.model,
    FilterName.style,
    FilterName.sub_style,
    FilterName.min_year_manufactured,
    FilterName.max_year_manufactured,
    FilterName.min_price,
    FilterName.max_price,
    FilterName.poa,
    FilterName.min_hours_used,
    FilterName.max_hours_used,
    FilterName.keywords,
])
defaultChannelGroupFiltersOrder.set(Channel.plant, [
    FilterName.distance,
    FilterName.make,
    FilterName.model,
    FilterName.style,
    FilterName.sub_style,
    FilterName.min_year_manufactured,
    FilterName.max_year_manufactured,
    FilterName.min_price,
    FilterName.max_price,
    FilterName.poa,
    FilterName.min_hours_used,
    FilterName.max_hours_used,
    FilterName.keywords,
])
defaultChannelGroupFiltersOrder.set(Channel.bikes, [
    FilterName.distance,
    FilterName.make,
    FilterName.model,
    FilterName.min_engine_size_cc,
    FilterName.max_engine_size_cc,
    FilterName.min_engine_power,
    FilterName.max_engine_power,
    FilterName.price_search_type,
    FilterName.min_price,
    FilterName.min_monthly_price,
    FilterName.max_price,
    FilterName.max_monthly_price,
    FilterName.min_year_manufactured,
    FilterName.max_year_manufactured,
    FilterName.body_type,
    FilterName.min_mileage,
    FilterName.max_mileage,
    FilterName.fuel_type,
    FilterName.colour,
    FilterName.seller_type,
    FilterName.is_writeoff,
    FilterName.keywords,
    FilterName.is_manufacturer_approved,
])
defaultChannelGroupFiltersOrder.set(Channel.caravans, [
    FilterName.make,
    FilterName.model,
    FilterName.style,
    FilterName.min_frame_size_cm,
    FilterName.max_frame_size_cm,
    FilterName.min_price,
    FilterName.max_price,
    FilterName.colour,
    FilterName.keywords,
])
defaultChannelGroupFiltersOrder.set(Channel.motorhomes, [
    FilterName.make,
    FilterName.model,
    FilterName.style,
    FilterName.min_frame_size_cm,
    FilterName.max_frame_size_cm,
    FilterName.min_price,
    FilterName.max_price,
    FilterName.min_seats,
    FilterName.max_seats,
    FilterName.colour,
    FilterName.keywords,
])
